<template>
    <div class="container-lg container-lg mt-2">

        <b-row class="pb-2">
            <b-col class="text-start">
                <h5>
                     <span class="downtime-icon-stack">
                         <i class="fa-solid fa-power-off"></i>
                         <i class="fa-solid fa-plus fa-xs ok cornered cornered-lr"></i>
                     </span>
                    {{ $t('forms.create-new-downtime', {obj: 'Host'}) }}
                </h5>
            </b-col>
        </b-row>

        <b-form>
            <b-form-group class="mb-3">
                <label class="typo__label" for="hostSelection">{{ $t('select') }} {{ $t('Hosts') }}</label>
                <span :class="{ 'is-invalid': v$.selectedHost.$error }">
                <multiselect v-model="selectedHost"
                             id="hostSelection"
                             label="value"
                             track-by="key"
                             placeholder="Type to search"
                             open-direction="bottom"
                             :options="hosts"
                             :multiple="true"
                             :searchable="true"
                             :loading="isLoading"
                             :internal-search="false"
                             :clear-on-select="false"
                             :close-on-select="false"
                             :options-limit="300"
                             :limit-text="limitText"
                             :max-height="600"
                             :show-no-results="false"
                             :hide-selected="true"
                             @search-change="getHosts"
                >
                    <template slot="clear" slot-scope="props">
                        <div class="multiselect__clear" v-if="selectedHost.length"
                             @mousedown.prevent.stop="clearAll(props.search)"></div>
                    </template>
                    <span slot="noResult">{{ $t('no-elements') }}</span>
                </multiselect>

            </span>
                <div class="invalid-feedback" v-if="v$.selectedHost.$error">{{ $t('Field is required') }}</div>
                <div class="invalid-feedback" v-for="error in validationErrors.object_id">{{ error }}</div>


            </b-form-group>

            <div class="mb-3">
                <label class="typo__label">{{ $t('forms.downtimetype') }}</label>
                <multiselect v-model="downtimeTypeSelected"
                             track-by="value"
                             :close-on-select="true"
                             :show-labels="false"
                             label="label"
                             placeholder="Select one"
                             :options="downtimeType"
                             :searchable="false"
                             :allow-empty="false">
                </multiselect>
            </div>

            <b-form-group
                :label="$t('comment')"
                label-for="downtimeComment" class="mb-3">
                <b-form-input id="downtimeComment"
                              :class="{ 'is-invalid': v$.downtimeComment.$error }"
                              v-model.trim="v$.downtimeComment.$model"
                              :placeholder="$t('comment')"></b-form-input>

                <!--<div class="invalid-feedback" v-for="error in validationErrors.comment">{{ error }}</div>-->
                <div class="invalid-feedback" v-if="v$.downtimeComment.required">{{ $t('Field is required') }}</div>
            </b-form-group>

            <b-form-group
                label-for="recurring"
                class="mb-3">
                <b-form-checkbox
                    id="recurring"
                    v-model="isRecurringDowntime"
                    name="recurringDowntimeCheckbox"
                >
                    {{ $t('forms.recurring-downtime') }}
                </b-form-checkbox>
            </b-form-group>

            <div v-if="!isRecurringDowntime">

                <b-form-group class="mb-3">
                    <label for="downtimeStart">Start</label>
                    <b-form-input
                        :class="{ 'is-invalid': this.validationErrors.from_date ||  this.validationErrors.from_time}"
                        v-model="downtimeStartTime" type="datetime-local"></b-form-input>
                    <div class="invalid-feedback" v-for="error in validationErrors.from_date">{{ error }}</div>
                    <div class="invalid-feedback" v-for="error in validationErrors.from_time">{{ error }}</div>
                </b-form-group>
                <b-form-group class="mb-3">
                    <label for="downtimeStart">{{ $t('end') }}</label>
                    <b-form-input
                        :class="{ 'is-invalid': this.validationErrors.to_date ||  this.validationErrors.to_time }"
                        v-model="downtimeEndTime" type="datetime-local"></b-form-input>
                    <div class="invalid-feedback" v-for="error in validationErrors.to_date">{{ error }}</div>
                    <div class="invalid-feedback" v-for="error in validationErrors.to_time">{{ error }}</div>
                </b-form-group>
            </div>
            <div v-if="isRecurringDowntime" class="ps-4">
                <b-form-group
                    class="mb-3"
                    label="Start"
                    label-for="recurringDowntimeStartTimeField">
                    <b-form-input :class="{ 'is-invalid': this.validationErrors.from_time}"
                                  v-model="recurringDowntimeStartTime" id="recurringDowntimeStartTimeField"
                                  type="time"></b-form-input>
                    <div class="invalid-feedback" v-for="error in validationErrors.from_time">{{ error }}</div>
                </b-form-group>
                <b-form-group :label="$t('forms.duration')" v-slot="{ ariaDescribedby }" class="mb-3">
                    <b-form-radio-group
                        id="downtimeDuration"
                        v-model="selectedDuration"
                        :options="downtimeQuickSelectOptions"
                        :aria-describedby="ariaDescribedby"
                        name="downtimeDurationGroup"
                        button-variant="outline-secondary"
                        class="flex-wrap"
                        buttons
                    ></b-form-radio-group>
                </b-form-group>
                <b-form-group
                    class="mb-3"
                    label-for="downtimeDurationTextField">
                    <b-form-input id="downtimeDurationTextField"
                                  :class="{ 'is-invalid': this.validationErrors.duration}"
                                  v-model="selectedDuration"
                                  placeholder="Duration in minutes"></b-form-input>
                    <div class="invalid-feedback" v-for="error in validationErrors.duration">{{ error }}</div>
                    <small>{{ selectedDuration }} {{ $t('forms.minutes') }}</small>
                </b-form-group>


                <b-form-group class="mb-3">
                    <label class="typo__label">{{ $t('forms.weekdays') }}</label>
                    <span :class="{ 'invalid is-invalid': this.validationErrors.weekdays }">
                    <multiselect v-model="selectedWeekdays" :options="weekdays"
                                 :searchable="false" :close-on-select="false"
                                 :show-labels="false" :multiple="true" placeholder="Pick a value" label="value"
                                 track-by="key"
                    ></multiselect>
                </span>
                    <div class="text-danger" v-if="recurringerror">{{ recurringerror }}</div>
                </b-form-group>
                <b-form-group
                    class="mb-3"
                    :label="$t('forms.monthdays')"
                    label-for="downtimeDaysOfMonthField">
                    <b-form-input :class="{ 'is-invalid': this.validationErrors.day_of_month}"
                                  id="downtimeDaysOfMonthField"
                                  v-model="daysOfMonth"
                                  placeholder="1,2,3,4,5 or <blank>"></b-form-input>
                    <div class="invalid-feedback" v-for="error in validationErrors.day_of_month">{{ error }}</div>
                </b-form-group>
            </div>

            <hr class="mt-4">

            <div class="d-flex w-100 justify-content-between">
                <b-button variant="danger" v-on:click="abort">{{ $t('dismiss') }}</b-button>
                <b-button variant="success" v-on:click="createDowntime">{{ $t('create-downtime') }}</b-button>
            </div>

        </b-form>

    </div>

</template>

<script>
import Multiselect from "vue-multiselect";
import {useToast} from "vue-toastification";
import {required} from '@vuelidate/validators';
import {useVuelidate} from '@vuelidate/core';
import { BForm } from 'bootstrap-vue-next';

export default {
    name: "DowntimesHostsAdd",
    components: {BForm, Multiselect},
    setup: () => ({v$: useVuelidate()}),
    data(){
        return {
            selectedHost: [],
            object_id: [],
            hosts: [],
            isLoading: false,
            downtimeType: [
                {
                    label: this.$t('hosts.individual'),
                    value: 'hostOnly'
                },
                {
                    label: this.$t('hosts.including-services'),
                    value: 'hostAndServices'
                },

            ],
            downtimeTypeSelected: {
                label: this.$t('hosts.individual'),
                value: 'hostOnly'
            },
            downtimetypeId: 0,
            downtimeComment: 'in progress',
            downtimeStartTime: '',
            downtimeEndTime: '',
            isRecurringDowntime: 0,
            recurringDowntimeStartTime: '',
            downtimeQuickSelectOptions: [
                {
                    text: '1m',
                    value: 1
                },
                {
                    text: '2m',
                    value: 2
                },
                {
                    text: '5m',
                    value: 5
                },
                {
                    text: '10m',
                    value: 10
                },
                {
                    text: '15m',
                    value: 15
                },
                {
                    text: '30m',
                    value: 30
                },
                {
                    text: '1h',
                    value: 60
                },
                {
                    text: '2h',
                    value: 60 * 2
                },
                {
                    text: '4h',
                    value: 60 * 4
                },
                {
                    text: '8h',
                    value: 60 * 8
                },

            ],
            selectedDuration: 15,
            weekdays: [
                {
                    key: 1,
                    value: this.$t('days.monday')
                },
                {
                    key: 2,
                    value: this.$t('days.tuesday')
                },
                {
                    key: 3,
                    value: this.$t('days.wednesday')
                },
                {
                    key: 4,
                    value: this.$t('days.thursday')
                },
                {
                    key: 5,
                    value: this.$t('days.friday')
                },
                {
                    key: 6,
                    value: this.$t('days.saturday')
                },
                {
                    key: 7,
                    value: this.$t('days.sunday')
                },
            ],
            selectedWeekdays: [],
            selectedWeekdayIds: [],
            daysOfMonth: '',
            validationErrors: {},
            recurringerror: false,
        }
    },
    props: [
        'hostuuid',
        'status',
        'services',
        'downtime',
    ],
    validations: {
        selectedHost: {
            required,
        },
        downtimeComment: {
            required
        },
    },
    computed: {
        getUuid: function(){
            return this.hostuuid;
        },
        getHostStatus: function(){
            return this.status;
        },
        getServices: function(){
            return this.services;
        },
        getDowntime: function(){
            return this.downtime;
        }
    },
    methods: {
        limitText(count){
            return `and ${count} other hosts`
        },
        getHosts(query){
            this.isLoading = true
            let listFilter = {
                filter: {
                    name: query,
                }
            };

           /* if(query.length === 0){
                this.isLoading = false;
                return;
            } */
            axios.post('/hosts/loadHostsByName.json', null, {
                params: {
                    filter: listFilter
                }
            })
                .then(response => {
                    this.hosts = response.data.hosts.hosts;
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    console.log('error: ' + error)
                });
        },
        clearAll(){
            this.selectedHost = []
        },
        splitDateTime: function(datetimeString){
            let fragment = datetimeString.split('T');
            return {
                date: fragment[0],
                time: fragment[1]
            };
        },
        getDurationInMinutes: function(startDate, endDate){
            //microseconds
            let diff = Math.abs(new Date(endDate) - new Date(startDate));
            let minutes = Math.floor((diff / 1000) / 60);
            return minutes;
        },
        createDowntime: async function(){
            this.v$.$touch();
            const validated = await this.v$.$validate();
            if(!validated){
                return;
            }
            if(this.isRecurringDowntime){
                if(this.selectedWeekdayIds.length === 0 && this.daysOfMonth === ''){
                    this.recurringerror = 'You must select at least one day of the week or one day of the month, or both';
                    return;
                }
            }

            let hostDowntime = {
                Systemdowntime: {
                    is_recurring: +this.isRecurringDowntime,
                    weekdays: this.selectedWeekdayIds,
                    day_of_month: this.daysOfMonth,
                    from_date: this.splitDateTime(this.downtimeStartTime).date,
                    from_time: this.splitDateTime(this.downtimeStartTime).time,
                    to_date: this.splitDateTime(this.downtimeEndTime).date,
                    to_time: this.splitDateTime(this.downtimeEndTime).time,
                    duration: this.getDurationInMinutes(this.downtimeStartTime, this.downtimeEndTime),
                    //downtimetype: 'host',
                    downtimetype_id: this.downtimetypeId, // host or host and services
                    objecttype_id: 256,     //OBJECT_HOST
                    object_id: this.object_id,          //HostIds
                    comment: this.downtimeComment,
                    is_recursive: 0 // only for containerdowntimes
                }
            };

            if(this.isRecurringDowntime){
                hostDowntime.Systemdowntime.from_date = '';
                hostDowntime.Systemdowntime.from_time = this.recurringDowntimeStartTime;
                hostDowntime.Systemdowntime.to_date = '';
                hostDowntime.Systemdowntime.to_time = '';
                hostDowntime.Systemdowntime.duration = this.selectedDuration;
            }
            axios.post('/downtimes/hosts_add.json', {downtime: hostDowntime})
                .then(response => {
                    useToast().success(this.$t('Command successfully sent'), {
                        timeout: 5000
                    });
                    this.validationErrors = {};
                    this.$router.push({
                        name: 'downtimesHost',
                        params: {
                            triggerRefresh: (this.isRecurringDowntime) ? 'tab2' : 'tab1'
                        }
                    });
                })
                .catch(error => {
                    useToast().error(this.$t('error'), {
                        timeout: 2000
                    });
                });

        },
        getTime: function(){
            axios.post('/downtimes/get_time.json', null, {})
                .then(response => {
                    this.recurringDowntimeStartTime = response.data.time;
                })
                .catch(error => {
                    console.log('error: ' + error)
                });
        },
        getDateTime(){
            axios.post('/downtimes/get_dates.json', null, {})
                .then(response => {
                    let datetime = response.data.datetime[0];
                    this.downtimeStartTime = datetime.start_time;
                    this.downtimeEndTime = datetime.end_time;

                })
                .catch(error => {
                    console.log('error: ' + error)
                });
        },
        abort(){
            this.$router.push({name: 'downtimesHost'});
        }
    },
    mounted(){
        this.getTime();
        this.getDateTime();
        this.getHosts();
    },
    watch: {
        selectedHost(newValues){
            //get the host ids from the selectbox
            this.object_id = newValues.map(obj => obj.key);
        },
        downtimeTypeSelected(val){
            if(val.value === 'hostAndServices'){
                this.downtimetypeId = 1;
            }else{
                this.downtimetypeId = 0;
            }
        },
        selectedWeekdays(values){
            this.selectedWeekdayIds = values.map(obj => obj.key);
        }
    }
}
</script>

<style scoped>

</style>
